// Js file for the popup box product customization.
$(document).ready(function(){
	$('.sel-cat-list').click(function(){
		$('.sel-cat-list.fab-col-active').removeClass('fab-col-active');
    	$(this).addClass("fab-col-active");
    	
    	//$('.changable-img').attr("src","images/opt-tiles/tile1_265.jpg");
    	
    	var imgUrl = $(this).data('img-url');
 		$('.changable-img').attr("src",imgUrl);
 		
 		var imgiconUrl = $(this).attr('src');
 		$('.sorune-options .active .sel-opt-thumb').attr("src",imgiconUrl);
		
		
		$('.data-cat-descr').text($(this).parents(".sel-category").data('cat-descr'));
 		$('.sel-cat-title').text($(this).parents(".sel-category").data('cat-id'));
 		$('.product-title1').text($('.sel-cat-list.fab-col-active').data('img-title'));
	});
	$('.carousel').carousel('pause')
	
	$('.opt-carosoul-nav.opt-carosoul-next').click(function(){
			if($('img.sel-cat-list.fab-col-active').parent()[0] != $('img.sel-cat-list').parent().last()[0])
			{
				var nextItem = $('img.sel-cat-list.fab-col-active').parent().next().children();
				if(nextItem.length == 0)
						nextItem = $('.sel-cat-list.fab-col-active').parents('.sel-category').next().find('li > img.sel-cat-list').first();
   				$('img.sel-cat-list.fab-col-active').removeClass('fab-col-active');
   				$(nextItem).addClass('fab-col-active');
   				

				var imgUrl = $('.sel-cat-list.fab-col-active').data('img-url');
				$('.changable-img').attr("src",imgUrl);
				
				$('.sorune-options .kirlent.active .sorune-thumb').attr("src",$('.sel-cat-list.fab-col-active').attr('src'));	
				$('.product-title1').text($('.sel-cat-list.fab-col-active').data('img-title'));
			}
 	});
 	$('.opt-carosoul-nav.opt-carosoul-prev').click(function(){
 		if($('img.sel-cat-list.fab-col-active').parent()[0] != $('img.sel-cat-list').parent().first()[0])
		{
 		   	var prevItem = $('.sel-cat-list.fab-col-active').parent().prev().children();
 		   	if(prevItem.length == 0)
				prevItem = $('.sel-cat-list.fab-col-active').parents('.sel-category').prev().find('li > img.sel-cat-list').last();
			$('img.sel-cat-list.fab-col-active').removeClass('fab-col-active');
 		   	prevItem.addClass('fab-col-active');
			var imgUrl = $('.sel-cat-list.fab-col-active').data('img-url');
			$('.changable-img').attr("src",imgUrl);
			$('.sorune-options .kirlent.active .sorune-thumb').attr("src",$('.sel-cat-list.fab-col-active').attr('src'));
/*			$('.product-titel.active').removeClass('active').parent().next().children().addClass('active');*/

			$('.product-title1').text($('.sel-cat-list.fab-col-active').data('img-title'));
		}
 	});
 	$('#fabric-selection').on('shown.bs.modal', function (e) {
 		
	})
 	$('.kirlent').click(function(){
 		var totSelctions = $('.sel-opt-list li').length;
 		var soruneThumb = $('.sorune-thumb.sel-opt-thumb').attr('src');
 		
			
 		$('.kirlent.active').removeClass('active');
 		$(this).addClass('active');
 		var currIndex = $('.sel-opt-list li').index($('.kirlent.active'));
 		$('.selection-count').text('('+(currIndex+1)+'/'+totSelctions+')');
 	});
 	$('.btn-green.btn-block').click(function(){
 		/*$('.kirlent.active').next().addClass('active');
 		$('.kirlent.active').prev().removeClass('active');*/
 		var selections = $('.sorune-thumb[src*=tile_white]').length;
 		if(selections > 0)
 		{
 			var oldLabel = $('.sel-opt-controls').parent().find('label.error');
 			if(oldLabel.length > 0)
 			{
 				$(oldLabel).stop().slideDown().delay(3000).slideUp();
 			}
 			else
 			{
     			$('.sel-opt-controls').before(
     				$('<label></label>').addClass('error text-center').text('Kaydedebilmek için tüm bileşenleri seçiniz')
     				.slideDown().delay(3000).slideUp()
     			);
	     	}
 		}
 	});

 	//filter fabrics
 	$('.kumas-filter').click(function(){
 		var fab_type = $(this).data('fab-type');
 		if(fab_type == 'flat')
 		{
 			$(".sel-cat-list.flat").parent().show();
 			$(".sel-cat-list.patterned").parent().hide();
 		} 
 		else if(fab_type == 'patterned')
 		{
 			$(".sel-cat-list.flat").parent().hide();
 			$(".sel-cat-list.patterned").parent().show();
 		}
 		else
 		{
 			$(".sel-cat-list.flat").parent().show();
 			$(".sel-cat-list.patterned").parent().show();
 		}

 		//change selected
 		$('.kumas-filter').removeClass('orange-text');
 		$(this).addClass('orange-text');
 	});
});